import { render } from "./EditButton.vue?vue&type=template&id=81e84de8&scoped=true"
import script from "./EditButton.vue?vue&type=script&lang=js"
export * from "./EditButton.vue?vue&type=script&lang=js"

import "./EditButton.vue?vue&type=style&index=0&id=81e84de8&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81e84de8"]])

export default __exports__